<template>
    <div>
        <loading v-show="isLoading"></loading>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                         <el-input
                            size="small"
                            style="width:230px;"
                            placeholder="请输入用户 姓名/手机号/QQ"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-select filterable  size="small" style="margin-left:30px;width:100px"   v-model="queryModel.status" clearable placeholder="审批状态">
                            <el-option key="2" label="待审核" value="2"> </el-option>
                            <el-option key="1" label="成功" value="1"> </el-option>
                            <el-option key="3" label="失败" value="3"> </el-option>
                        </el-select>
                        <el-select filterable  size="small" style="margin-left:30px;width:100px"   v-model="queryModel.payType" clearable placeholder="打款方式">
                            <el-option key="1" label="银行卡" value="1"> </el-option>
                            <el-option key="2" label="微信" value="2"> </el-option>
                            <el-option key="3" label="支付宝" value="3"> </el-option>
                            <el-option key="4" label="微信自动" value="4"> </el-option>
                        </el-select>
                        <el-select size="small" filterable   style="margin-left:30px;width:100px"   v-model="queryModel.outsiderId" clearable placeholder="兼职人员">
                            <el-option v-for="(v) in outsiderList" :key="v.Id" :label="v.Name" :value="v.Id"> </el-option>
                        </el-select>
                        <el-date-picker
                         value-format="yyyy-MM-dd HH:mm:ss"
                        size="small" style="width:250px;margin-left:30px"
                        v-model="queryModel.createTimes"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>

                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                          <el-button @click="assign" size="small" style="margin-left:20px" type="primary">重新分配</el-button>
                         <el-button type="success" @click="getExl" icon="el-icon-download" style="margin-left:20px" size="small" plain>导出结果</el-button>
                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                     @selection-change="handleSelectionChange"
                    v-loading="isLoading"
                    :height="bodyHeight-130"
                    :data="tableData"
                    style="width: 100%">
                        <el-table-column
                        :selectable='checkboxInit'
                        type="selection"
                        width="55">
                        </el-table-column>
                        <el-table-column
                        width="100"
                            prop="Id"
                            label="单据Id">
                        </el-table-column>
                        <el-table-column
                        width="100"
                            prop="AccountNmae"
                            label="姓名">
                        </el-table-column>
                        <el-table-column
                            prop="Phone"
                            label="用户手机">
                        </el-table-column>
                        <el-table-column
                        width="80"
                            label="转款方式">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.PayType==1"  size="mini"  effect="dark">
                                    银行卡
                                </el-tag>
                                <el-tag  size="mini" v-else-if="scope.row.PayType==2"   effect="dark">
                                    微信
                                </el-tag>
                                <el-tag  size="mini" v-else-if="scope.row.PayType==3"   effect="dark">
                                    支付宝
                                </el-tag>
                                <el-tag  size="mini" v-else-if="scope.row.PayType==4"   effect="dark">
                                    微信自动
                                </el-tag>
                                <el-tag  size="mini" v-else    effect="dark">
                                    暂无
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="金额">
                            <template slot-scope="scope">
                                  <el-link type="primary">￥{{scope.row.Money}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="160"
                            prop="CreateTime"
                            label="申请时间">
                        </el-table-column>
                        <el-table-column
                         width="160"
                            prop="ReviewTime"
                            label="审核时间">
                        </el-table-column>
                        <el-table-column
                         width="140"
                            prop="BankAccountName"
                            label="开户行">
                        </el-table-column>
                        <el-table-column
                         width="240"
                            label="银行卡号">
                            <template slot-scope="scope">
                                <el-link @click="copy(scope.row)" icon="el-icon-copy-document" type="primary">{{scope.row.BankCardNo}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="收款码">
                            <template slot-scope="scope">
                                <el-link target="_blank"  @click="showImg(scope.row)" type="primary">点击查看</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="状态">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" v-if="scope.row.Status==2">待审核</el-tag>
                                <el-tag size="mini" effect="plain" type="success" v-else-if="scope.row.Status==1">成功</el-tag>
                                <el-tag size="mini" effect="plain" type="danger" v-else-if="scope.row.Status==3">失败</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="Name"
                            label="负责人">
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog
  title="提示"
  :visible.sync="assignVisible"
  width="300px">
  <el-select size="small" style="margin-left:30px;width:200px"  v-model="selOutsiderId" clearable placeholder="请选择分配目标">
        <el-option v-for="(v) in outsiderList" :key="v.Id" :label="v.Name" :value="v.Id"> </el-option>
    </el-select>
  <span slot="footer" class="dialog-footer">
    
    <el-button @click="assignVisible = false">取 消</el-button>
    <el-button type="primary" @click="assignSumbit">确 定</el-button>
  </span>
</el-dialog>

        <el-image-viewer 
                v-show="showViewer" 
                :on-close="closeImg" 
                :url-list="[url]" />
    </div>
</template>
<script>
import { swipeBillGet,swipeBillReview,outsiderGetSel,swipeAssign,uri} from '@/request.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { formatDate } from '@/commonUtil.js'
export default {
    components: {
        ElImageViewer
    },
    props:{
      manger:{
        type:Object,
        required: true
      }
    },
    data(){
        return {
            assignVisible:false,
            multipleSelection: [],
            url:"",
            showViewer:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
                status:"",
                outsiderId:"",
                createTimes:[],
                payType:"",
            },
            tableData:[],
            outsiderList:[],
            selOutsiderId:"",
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
       outsiderGetSel({type:1},(res)=>{
           this.outsiderList=res.Result;
       });
    },
    methods: {
        getExl(){
            let arr=[]
            this.queryModel.createTimes.forEach(x=>{
                arr.push(formatDate(new Date(x),"yyyy-MM-dd"))
            });
           window.open(uri+"/SwipeBill/GetExl?queryTxt="+this.queryModel.queryTxt+"&outsiderId="+(this.queryModel.outsiderId==""?0:parseInt(this.queryModel.outsiderId))+"&status="+(this.queryModel.status==""?0:parseInt(this.queryModel.status))+"&payType="+(this.queryModel.payType==""?0:parseInt(this.queryModel.payType))+"&createTimes="+(this.queryModel.createTimes==null?"[]":JSON.stringify(arr))
           );
        },  
        assignSumbit(){
            var ids="";
            this.multipleSelection.forEach(x=>{
                ids+=x.Id+",";
            })
            ids=ids.substring(0,ids.length-1);
            swipeAssign({ids:ids,outsiderId:this.selOutsiderId},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.assignVisible=false;
                        this.query();
                    }else{
                        this.$message.error(res.Message);
                    }
            })
        },
        assign(){
            if(this.multipleSelection.length==0){
                this.$message({
                    message: '请先选择需要重新分配的行',
                    type: 'warning'
                });
                return;
            }
            this.assignVisible=true;
        },
        checkboxInit(row) {
            if (row.Status!=2) {
                return 0; //不可勾选
            } else {
                return 1;
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pass(scope){
            this.$confirm('确认该提现申请已打款吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                swipeBillReview({id:scope.Id,status:1},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '提现成功',
                            type: 'success'
                        });
                        scope.Status=1;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        over(scope){
            this.$confirm('确认拒绝该提现申请吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                swipeBillReview({id:scope.Id,status:3},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        scope.Status=3;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        closeImg(){
            this.showViewer=false;
        },
        showImg(scope){
            this.url=scope.CollectionCode;
            this.showViewer=true;
        },
        query(){
            this.isLoading=true;
            swipeBillGet({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                queryTxt:this.queryModel.queryTxt,
                status:this.queryModel.status==""?0:parseInt(this.queryModel.status),
                outsiderId:this.queryModel.outsiderId==""?0:parseInt(this.queryModel.outsiderId),
                createTimes:this.queryModel.createTimes==null?"[]":JSON.stringify(this.queryModel.createTimes),
                payType:this.queryModel.payType==""?0:parseInt(this.queryModel.payType),
            },(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
                status:"",
                createTimes:[]
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>